import { interpolate } from '../../core/sceneGraph/sceneGraph.js';
import { GroupByVariable } from './GroupByVariable.js';

const allActiveGroupByVariables = /* @__PURE__ */ new Set();
function findClosestGroupByInHierarchy(dsUid, sceneObject) {
  var _a, _b, _c;
  let current = sceneObject;
  while (current) {
    const variables = (_b = (_a = current.state.$variables) == null ? void 0 : _a.state.variables) != null ? _b : [];
    for (const variable of variables) {
      if (variable instanceof GroupByVariable && interpolate(variable, (_c = variable.state.datasource) == null ? void 0 : _c.uid) === dsUid) {
        return variable;
      }
    }
    current = current.parent;
  }
  return void 0;
}
function findGlobalGroupByVariableByUid(dsUid) {
  var _a;
  for (const groupByVariable of allActiveGroupByVariables.values()) {
    if (interpolate(groupByVariable, (_a = groupByVariable.state.datasource) == null ? void 0 : _a.uid) === dsUid) {
      return groupByVariable;
    }
  }
  return void 0;
}

export { allActiveGroupByVariables, findClosestGroupByInHierarchy, findGlobalGroupByVariableByUid };
//# sourceMappingURL=findActiveGroupByVariablesByUid.js.map
